import React from 'react';
import { useTranslation } from 'react-i18next';

// Import images statically
import logo1 from '../../assets/images/logo/logo1.png';
import logo2 from '../../assets/images/logo/logo2.png';
import logo3 from '../../assets/images/logo/logo3.png';
import logo4 from '../../assets/images/logo/logo4.png';
import logo7 from '../../assets/images/logo/logo7.png';

const logos = [
  logo1,
  logo2,
  logo3,
  logo7,
  logo1,
  logo2,
  logo3,
  logo4,
  logo7,
  logo1,
  logo2,
  logo3,
  logo4,
];

const ClientCarousel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="client_carousel py-5">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="content_wrapper">
              <p>{t('client_carousel_description')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container overflow-hidden mt-3">
        <div className="slid-er">
          <div className="slides d-flex">
            {logos.map((logo, index) => (
              <div className="slide" key={index}>
                <div className="slide-content">
                  <a href="#">
                    <img src={logo} alt={`Logo ${index + 1}`} loading="lazy" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .client_carousel {
          background: #fff;
        }
        .slid-er {
          position: relative;
          width: 100%;
          overflow: hidden;
          height: 100px;
        }
        .slides {
          display: flex;
          width: fit-content;
          animation: scrollLeft 40s linear infinite;
        }
        .slide {
          flex: 0 0 auto;
          margin: 0 -40px;
          display: flex;
          align-items: center;
        }
        .slide img {
          max-height: 90px;
          width: auto;
          object-fit: contain;
          display: block;
        }
        @keyframes scrollLeft {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};

export default ClientCarousel;
